(function () {
    var form = document.querySelector('#contact-form');
    if (!form) {
        return;
    }
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = document.getElementById('contact-name').value.trim();
        var email = document.getElementById('contact-mail').value.trim();
        var message = document.getElementById('contact-message').value.trim();
        var submitButton = document.getElementById('contact-submit');
        submitButton.disabled = true;
        var handleError = function () {
            submitButton.disabled = false;
            submitButton.innerText = "Send";
            alert('Failed to submit form');
        };
        if (name === '' || email === '' || message === '') {
            alert('Invalid input');
            return;
        }
        submitButton.innerText = "Loading...";
        fetch('https://api.nehalist.io/contact', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: name,
                email: email,
                message: message
            })
        })
            .then(function (res) {
            if (res.status !== 200) {
                handleError();
                return;
            }
            document.getElementById('contact-success').classList.remove('hidden');
            submitButton.remove();
        })
            .catch(function () { return handleError(); });
    });
})();
